import {FormGridSectionItem, FormGridSectionSubTitle, FormGridSectionTitle} from '@/components/ui/form-atoms/FormAtoms'
import {StyledFormSection} from './style'
import {HTMLAttributes} from 'react'
import {useTranslation} from '@/translations/i18n'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'

type FormSectionProps = HTMLAttributes<HTMLDivElement> & {
    title: string
    subTitle?: string
    description?: string
    isOptional?: boolean
    hasTopDivider?: boolean
    hasBottomDivider?: boolean
    fullWidth?: boolean
}

export const FormSection = ({
    title,
    subTitle,
    description,
    isOptional,
    children,
    hasBottomDivider,
    hasTopDivider,
    fullWidth,
    ...props
}: FormSectionProps) => {
    const {t} = useTranslation()

    return (
        <>
            {hasTopDivider && <Divider direction="horizontal" />}
            <StyledFormSection $fullWidth={fullWidth} {...props}>
                <FormGridSectionItem>
                    <Flexbox direction="column" gap={1}>
                        <div>
                            <FormGridSectionTitle>
                                {title}
                                {isOptional && <span className="description"> ({t('commons:optional')})</span>}
                            </FormGridSectionTitle>
                            {subTitle && <FormGridSectionSubTitle>{subTitle}</FormGridSectionSubTitle>}
                        </div>
                        {description && (
                            <Text size="textXs" palette="neutral" shade="500">
                                {description}
                            </Text>
                        )}
                    </Flexbox>
                </FormGridSectionItem>
                <FormGridSectionItem>{children}</FormGridSectionItem>
            </StyledFormSection>
            {hasBottomDivider && <Divider direction="horizontal" />}
        </>
    )
}
